require("./bootstrap");

window.Vue = require("vue").default;

import Vue from "vue";
import vuetify from "./plugins/vuetify";
import store from "./store";
import Vuebar from "vuebar";
import VueMoment from "vue-moment";
import i18n from "./plugins/i18n";

import { mapActions, mapMutations } from "vuex";
import { SET_LOADING, SET_ERRORS } from "./utils/constants";

Vue.use(store);
Vue.use(Vuebar);
Vue.use(VueMoment);

const files = require.context("./", true, /\.vue$/i);

Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0);
Vue.prototype.$_ = window._;

files.keys().map(key =>
  Vue.component(
    key
      .split("/")
      .pop()
      .split(".")[0],
    files(key).default
  )
);

const app = new Vue({
  el: "#app",
  vuetify,
  store,
  i18n,
  created() {
    this.enableInterceptor();
  },
  methods: {
    ...mapMutations("Axios", [SET_LOADING]),
    ...mapActions("Axios", ["setMessage"]),
    ...mapActions(["reset"]),
    ...mapMutations([SET_ERRORS]),
    enableInterceptor() {
      axios.interceptors.request.use(
        config => {
          this.SET_LOADING(true);
          return config;
        },
        error => {
          this.SET_LOADING(false);
          this.SET_ERRORS(error);
          return Promise.reject(error);
        }
      );

      axios.interceptors.response.use(
        response => {
          this.SET_LOADING(false);
          this.reset();
          window.scrollTo({ top: 0, behavior: "smooth" });
          const message = response.data.message || null;

          if (message) {
            this.setMessage({
              message,
              showSnackbar: true,
              isError: false
            });
          }
          return response;
        },
        error => {
          this.SET_LOADING(false);
          const err = error.response.data.errors || {};

          let errorMessage = error.response.data.message || "";

          if (!errorMessage) {
            errorMessage = error.message;
          }

          if (error.response.config.url !== "me") {
            this.setMessage({
              message: this.$t(errorMessage),
              showSnackbar: true,
              isError: true
            });

            this.SET_ERRORS(err);
          }
          return Promise.reject(error);
        }
      );
    }
  }
});
